

export const tables = {

    GroupReport: [{
        name: 'EMAIL ID',
        key: 'participant__email',
        type: 'text',
        link: ''
    },{
        name: 'NAME',
        key: 'participant__full_name',
        type: 'text',
        link: ''
    },{
        name: 'BATCH',
        key: 'batch__batch_name',
        type: 'text',
        link: ''
    },{
        name: 'PROCESSING DATE',
        key: 'expiry_date',
        type: 'date',
        link: ''
    }],
    
    ManageBatches: [{
        name: 'Batch Name',
        key: 'batch_name',
        type: 'text',
        content: '',
        linkActive: true,
        link: '',
        sort: true,
    },
    {
        name: 'Batch Code',
        key: 'batch_code',
        type: 'text',
        content: '',
        linkActive: false,
        link: '',
        sort: true,
    },
    {
        name: '#Participants',
        key: 'participants_count',
        type: 'text',
        content: '',
        linkActive: false,
        link: '',
        sort: true,
    },
    {
        name: 'Mandate Group',
        key: 'organisation_mandate_group__assessor_group__assessor_name',
        type: 'text',
        content: '',
        linkActive: false,
        link: '',
        sort: true
    },
    {
        name: 'Min Respondents',
        key: 'min_respondent',
        type: 'text',
        content: '',
        linkActive: false,
        link: '',
        sort: true,
    },
    {
        name: 'Delete Batch',
        key: 'delete',
        type: 'icon',
        content: 'remove',
        linkActive: false,
        link: '',
        sort: true,
    }],
    BatchDetails: [{
        name: 'Seller',
        key: 'seller__seller_name',
        type: 'text',
        content: '',
        linkActive: false,
        link: '',
        sort: true,
    },
    {
        name: 'Organisation',
        key: 'organisation__organisation_name',
        type: 'text',
        content: '',
        linkActive: false,
        link: '',
        sort: true,
    },
    {
        name: 'Batch',
        key: 'batch_name',
        type: 'text',
        content: '',
        linkActive: false,
        link: '',
        sort: true,
    },
    {
        name: 'Min Respondents',
        key: 'min_respondent',
        type: 'text',
        content: '',
        linkActive: false,
        link: '',
        sort: true,
    },{
        name: 'Mandate Group',
        key: 'organisation_mandate_group__assessor_group__assessor_name',
        type: 'text',
        linkActive: false,
        link: '',                
    }
    ],
    Participants: [
        {
            name: 'PARTICIPANT EMAIL ID',
            key: 'email',
            type: 'text',
            content: '',
            linkActive: false,
            link: '',
            sort: true,
        },
        {
            name: 'PARTICIPANT NAME',
            key: 'full_name',
            type: 'text',
            content: '',
            linkActive: false,
            link: '',
            sort: true,
        },
        {
            name: 'PAST ASSESSMENTS',
            key: 'previous_assesment',
            type: 'logoText',
            content: '',
            linkActive: false,
            link: '',
            sort: true,
            filter: false
        },
        {
            name: 'ACTIVE ASSESSMENTS',
            key: 'active_assessment',
            type: 'logoText',
            content: '',
            linkActive: false,
            link: '',
            sort: true,
            filter: false            
        },
        // {
        //     name: 'PI ACCESS',
        //     key: 'user_access__is_pi_enabled',
        //     type: 'tickmark',
        //     content: '',
        //     linkActive: false,
        //     link: '',
        //     sort: true,
        // }
    ],
    ActiveAssesments: [
        {
            name: 'PARTICIPANT',
            key: 'participants',
            type: 'text',
            content: '',
            linkActive: false,
            link: ''
        },
        {
            name: 'TYPE',
            key: 'type',
            type: 'text',
            content: '',
            linkActive: false,
            link: ''
        },
        {
            name: 'EXPIRY DATE',
            key: 'expiry_date',
            type: 'date',
            content: '',
            linkActive: false,
            link: ''
        },
        {
            name: 'REPORT THEME',
            key: 'report_theme',
            type: 'text',
            content: '',
            linkActive: false,
            link: ''
        },
        {
            name: 'DEV PLAN',
            key: 'dev_plan',
            type: 'text',
            content: '',
            linkActive: false,
            link: ''
        },
        // {
        //     name: 'REPORT ACCESS',
        //     key: 'report_accesss',
        //     type: 'modalOpeners',
        //     content: '',
        //     linkActive: false,
        //     link: ''
        // },
        {
            name: 'SUBMITTED',
            key: 'submitted',
            type: 'tickmark',
            content: '',
            linkActive: false,
            link: ''
        },
        {
            name: 'REPORT ENABLED',
            key: 'report_enabled',
            type: 'tickmark',
            content: '',
            linkActive: false,
            link: ''
        },
    ],
    UnallotedAssesments: [
        {
            name: 'PARTICIPANT',
            key: 'participant__email',
            type: 'text',
            content: '',
            linkActive: false,
            link: '',
            sort: true
        },
        {
            name: 'TYPE',
            key: 'instrument__instrument_name',
            type: 'text',
            content: '',
            linkActive: false,
            link: '',
            sort: true,
            textAlign: 'center'
        },
        {
            name: 'EXPIRY DATE',
            key: 'expiry_date',
            type: 'date',
            content: '',
            linkActive: false,
            link: '',
            sort: true,
            textAlign: 'center'            
        },
        // {
        //     name: 'REPORT THEME',
        //     key: 'report_theme__report_theme_name',
        //     type: 'text',
        //     content: '',
        //     linkActive: false,
        //     link: '',
        //     sort: true,
        //     textAlign: 'center'            
        // },
        {
            name: 'DEV PLAN',
            key: 'dev_plan',
            type: 'text',
            content: '',
            linkActive: false,
            link: '',
            sort: true,
            textAlign: 'center'            
        },
        // {
        //     name: 'REPORT ACCESS',
        //     key: 'default_report',
        //     type: 'modalOpeners',
        //     modalStyle: 'link',
        //     content: '',
        //     linkActive: false,
        //     link: '',
        //     sort: true,
        //     textAlign: 'center'            
        // },
        {
            name: 'SUBMITTED',
            key: 'is_submited',
            type: 'tickmark',
            content: '',
            linkActive: false,
            link: '',
            sort: true,
            textAlign: 'center'            
        },
        {
            name: 'REPORT ENABLED',
            key: 'enable_report',
            type: 'tickmark',
            content: '',
            linkActive: false,
            link: '',
            sort: true,
            textAlign: 'center'            
        },
    ],
    UnallotedAssesments_seller_admin: [{
        name: 'PARTICIPANT',
        key: 'participant__email',
        type: 'text',
        content: '',
        linkActive: false,
        link: '',
        sort: true
    },
    {
        name: 'TYPE',
        key: 'instrument__instrument_name',
        type: 'text',
        content: '',
        linkActive: false,
        link: '',
        sort: true,
        textAlign: 'center'
    },
    {
        name: 'EXPIRY DATE',
        key: 'expiry_date',
        type: 'date',
        content: '',
        linkActive: false,
        link: '',
        sort: true,
        textAlign: 'center'            
    },
    {
        name: 'SUBMITTED',
        key: 'is_submited',
        type: 'tickmark',
        content: '',
        linkActive: false,
        link: '',
        sort: true,
        textAlign: 'center'            
    },
    {
        name: 'REPORT ENABLED',
        key: 'enable_report',
        type: 'tickmark',
        content: '',
        linkActive: false,
        link: '',
        sort: true,
        textAlign: 'center'
    }],
    UnallotedAssesments_org_admin: [
        {
            name: 'PARTICIPANT',
            key: 'participant__email',
            type: 'text',
            content: '',
            linkActive: false,
            link: '',
            sort: true
        },
        {
            name: 'TYPE',
            key: 'instrument__instrument_name',
            type: 'text',
            content: '',
            linkActive: false,
            link: '',
            sort: true,
            textAlign: 'center'
        },
        {
            name: 'EXPIRY DATE',
            key: 'expiry_date',
            type: 'date',
            content: '',
            linkActive: false,
            link: '',
            sort: true,
            textAlign: 'center'            
        },
        {
            name: 'SUBMITTED',
            key: 'is_submited',
            type: 'tickmark',
            content: '',
            linkActive: false,
            link: '',
            sort: true,
            textAlign: 'center'            
        }
    ]
}



// WEBPACK FOOTER //
// ./src/_pages/Admin/Organisation/DetailLinks/CustomColumnTable.js